<template lang="pug">
v-navigation-drawer(v-model="showDrawer" mobile-breakpoint="xs" width=375 temporary right app bottom)
  KeepAlive(include="main")
    div(v-if="page === 'main'")
      .d-flex.align-center.top-0.sticky.z-10.white.pa-6
        .h5 {{ $t('add_filter') }}
        v-spacer
        .link-s(@click="clearFilters") {{ $t('clear_all_filters') }}
        
      .h-screen.overflow-y-auto.px-6.pb-48
        div(v-for="item in items")
          .mb-4(v-if="getChanges(item).length")
            .d-flex.align-center
              .flex-grow-1
                .text-md.font-medium Filter {{ item.name | capitalize }}
                .text-sm.font-normal.primary400--text(v-for="(changes, index) in getChanges(item)" :key="index") {{ changes }}
              v-menu(offset-y min-width=200)
                template(v-slot:activator="{ on, attrs }")
                  v-btn(v-on="on" color="primary400" icon)
                    v-icon mdi-dots-horizontal
                v-list.py-0
                  v-list-item(@click="openDetail(item)")
                    .text-sm Edit Filter
                  v-divider.basic300
                  v-list-item(@click="deleteFilter(item)")
                    .text-sm.danger500--text Delete Filter
            v-divider.mt-4
        div(v-for="item in items")
          v-btn.py-7.mb-3.round-xl.hover-bg(v-if="!getChanges(item).length" @click="openDetail(item)" :key="item.type" outlined color="#ddd" block)
            .text-md.font-medium.text-none.neutral700--text Filter {{ item.name | capitalize }}
            v-spacer
            eva-icon.d-flex(name="arrow-ios-forward" fill="#888")

      .absolute.bottom-0.left-0.right-0.white.px-6.py-4
        v-btn.button-md.white--text(@click="clickDone" color="info500" block depressed) {{ $t('done') }}

    filter-segment(v-else-if="page === 'segment'" :filter.sync="segmentFilter" @onBack="back")
    filter-alphanumeric(v-else-if="page === 'name'" type="name" :filter.sync="nameFilter" @onBack="back")
    filter-alphanumeric(v-else-if="page === 'nickname'" type="nickname" :filter.sync="nicknameFilter" @onBack="back")
    filter-alphanumeric(v-else-if="page === 'email'" type="email" :filter.sync="emailFilter" @onBack="back")
    filter-alphanumeric(v-else-if="page === 'phone'" type="phone" :filter.sync="phoneFilter" @onBack="back")
    filter-gender(v-else-if="page === 'gender'" :filter.sync="genderFilter" @onBack="back")
    filter-date(v-else-if="page === 'created'" :filter.sync="dateFilter" @onBack="back")
    filter-age(v-else-if="page === 'age'" :filter.sync="ageFilter" @onBack="back")
    filter-order-count(v-else-if="page === 'order_count'" :filter.sync="countFilter" @onBack="back")
    filter-custom-field(v-else-if="page === 'custom'" :filter="selectedCustomFilter" @onFiltered="onFiltered" @onBack="back")

</template>

<script>
import clone from 'just-clone'
import { mapGetters } from 'vuex'

import FilterSegment from './FilterSegment.vue'
import FilterAlphanumeric from './FilterAlphanumeric.vue'
import FilterGender from './FilterGender.vue'
import FilterDate from './FilterDate.vue'
import FilterAge from './FilterAge.vue'
import FilterOrderCount from './FilterOrderCount.vue'
import FilterCustomField from './FilterCustomField.vue'

export default {
  props: ['open', 'filterData'],
  components: {
    FilterSegment,
    FilterAlphanumeric,
    FilterGender,
    FilterDate,
    FilterAge,
    FilterOrderCount,
    FilterCustomField
  },
  data: () => ({
    page: 'main',
    segmentFilter: {},
    nameFilter: {},
    nicknameFilter: {},
    emailFilter: {},
    phoneFilter: {},
    genderFilter: {},
    dateFilter: {},
    ageFilter: {},
    countFilter: {},
    selectedCustomFilter: {},
    customDataFilter: new Map()
  }),
  computed: {
    ...mapGetters({
      customFields: 'customers/getCustomFields'
    }),
    showDrawer: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    items () {
      const defaultItems = [
        { name: 'segment', type: 'segment' },
        { name: 'name', type: 'name' },
        { name: 'nickname', type: 'nickname' },
        { name: 'email', type: 'email' },
        { name: 'contact number', type: 'phone' },
        { name: 'order count', type: 'order_count' },
        { name: 'age', type: 'age' },
        { name: 'date (created on)', type: 'created' },
        { name: 'gender', type: 'gender' }
      ]
      const customItems = []
      if (this.customFields.length) {
        this.customFields.forEach(item => {
          const obj = {
            name: item.field_name,
            type: 'custom',
            datatype: item.datatype,
            id: item.id
          }
          customItems.push(obj)
        })
      }
      return [...defaultItems, ...customItems]
    }
  },
  methods: {
    clearFilters () {
      this.segmentFilter = {}
      this.nameFilter = {}
      this.nicknameFilter = {}
      this.emailFilter = {}
      this.phoneFilter = {}
      this.genderFilter = {}
      this.dateFilter  = {}
      this.ageFilter = {}
      this.countFilter = {}
      this.customDataFilter = new Map()
    },
    clickDone () {
      const filters = {
        name: this.nameFilter.exact,
        name__contains: this.nameFilter.all,
        name__exclude: this.nameFilter.none,
        nickname: this.nicknameFilter.exact,
        nickname__contains: this.nicknameFilter.all,
        nickname__exclude: this.nicknameFilter.none,
        email: this.emailFilter.exact,
        email__contains: this.emailFilter.all,
        email__exclude: this.emailFilter.none,
        phone: this.phoneFilter.exact,
        phone__exclude: this.phoneFilter.none,
        gender: this.genderFilter.gender,
        created__before: this.dateFilter.before,
        created__after: this.dateFilter.after,
        created__on: this.dateFilter.on,
        groups: this.segmentFilter.segments?.join(','),
        total_orders: this.countFilter.equal,
        total_orders__gt: this.countFilter.more,
        total_orders__lt: this.countFilter.less,
        age: this.ageFilter.equal,
        age__gt: this.ageFilter.more,
        age__lt: this.ageFilter.less,
        custom_data: this.customDataFilter
      }
      this.$store.commit('customers/setFilters', filters)
      this.showDrawer = false
    },
    openDetail (item) {
      const type = item.type
      if (type === 'custom') {
        const filter = item
        const filterData = this.customDataFilter.get(item.id)
        if (filterData) {
          filter.data = filterData
        }
        this.selectedCustomFilter = filter
      }
      this.page = type
    },
    deleteFilter (item) {
      switch (item.type) {
        case 'name':
          this.nameFilter = {}
          break
        case 'nickname':
          this.nicknameFilter = {}
          break
        case 'email':
          this.emailFilter = {}
          break
        case 'phone':
          this.phoneFilter = {}
          break
        case 'gender':
          this.genderFilter = {}
          break
        case 'created':
          this.dateFilter = {}
          break
        case 'segment':
          this.segmentFilter = {}
          break
        case 'order_count':
          this.countFilter = {}
          break
        case 'age':
          this.ageFilter = {}
          break
        case 'custom':
          this.nameFilter = clone(this.nameFilter)
          this.customDataFilter.delete(item.id)
          break
      }
    },
    back () {
      this.page = 'main'
    },
    onFiltered (filter) {
      this.customDataFilter.set(filter.id, filter.data)
    },
    getChanges (item) {
      const type = item.type
      let changes = []
      let obj = {}
      switch (type) {
        case 'name':
          obj = this.nameFilter
          break
        case 'nickname':
          obj = this.nicknameFilter
          break
        case 'email':
          obj = this.emailFilter
          break
        case 'phone':
          obj = this.phoneFilter
          break
        case 'gender':
          obj = this.genderFilter
          break
        case 'created':
          obj = this.dateFilter
          break
        case 'segment':
          obj = this.segmentFilter
          break
        case 'order_count':
          obj = this.countFilter
          break
        case 'age':
          obj = this.ageFilter
          break
      }
      for (const key in obj) {
        const val = obj[key]
        if (val) {
          if (key !== 'segments') {
            const name = this.getNameFromFilterKey(key, type)
            let description = val
            if (key === 'segment_titles') {
              description = val.join(', ')
            }
            if (key === 'gender')  {
              description = this.$options.filters.capitalize(val)
            }
            changes.push(`${name} ${description}`)
          }
        }
      }
      if (type === 'custom') {
        for (const [filterKey, val] of this.customDataFilter) {
          if (filterKey == item.id && val) {
            for (const k in val) {
              const desc = val[k]
              if (desc) {
                const name = this.getNameFromFilterKey(k, type)
                changes.push(`${name} ${desc}`)
              }
            }
          }
        }
      }
      return changes
    },
    getNameFromFilterKey (key, type){
      switch (key) {
        case 'segment_titles':
          return 'Segment choosen:'
        case 'all':
        case 'icontains':
          return 'All of these words:'
        case 'exact':
        case 'iexact':
          return type === 'age' ? 'Exact age of ' :'Exact word:'
        case 'none':
          return 'None of these words:'
        case 'more':
        case 'gt':
          return type === 'age' ? 'Older than' : 'More than'
        case 'less':
        case 'lt':
          return type === 'age' ? 'Younger than' : 'Less than'
        case 'before':
          return 'Before'
        case 'after':
          return 'After'
        case 'gender':
          return 'Gender: '
      }
      return key
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
  max-height: 100% !important;
}
</style>